import styled from '@emotion/styled';

import vars from 'theme/styles/vars';

export default styled.div`
	display: flex;
	justify-content: space-between;
	align-items: center;

	.breadcrumbs-list {
		display: flex;
		justify-content: flex-start;
		padding: 3em 0;

		li {
			position: relative;

			&:last-child {
				font-weight: 700;
				text-overflow: ellipsis;
				max-width: 20ch;
				white-space: nowrap;
				overflow: hidden;
			}

			&:not(:last-child) {
				margin-right: 1em;
				&::after {
					content: '>';
					position: absolute;
					right: -0.8em;
					top: 0.1em;
				}
			}

			.breadcrumb-link {
				text-decoration: none;
				font-size: 0.8em;
				color: #000000;

				&:hover {
					text-decoration: underline;
				}
			}
		}
	}

	.sponsored-article {
		font-size: 0.8em;
		text-transform: uppercase;
		min-width: max-content;
		color: ${vars.colorTextLighter};
	}

	@media all and (max-width: ${vars.desktopXS}) {
		.breadcrumbs-list {
			li {
				.breadcrumb-link {
					font-size: 0.65em;
				}
			}
		}
	}

	@media all and (max-width: ${vars.tabletL}) {
		flex-flow: column;
		align-items: flex-start;

		.breadcrumbs-list {
			flex-flow: row wrap;
			max-width: max-content;
		}

		.sponsored-article {
			font-size: 0.8em;
			transform: translateY(-3em);
		}
	}

	@media all and (max-width: ${vars.mobileS}) {
		.breadcrumbs-list {
			li {
				.breadcrumb-link {
					font-size: 0.55em;
				}
			}
		}
	}
`;
